import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Building2, CreditCard, FileText, Inbox } from "lucide-react";
import api from "../../lib/api";

export default function AdminDashboard() {
  const [stats, setStats] = useState(null);

  useEffect(() => {
    api.get("/admin/stats").then(({ data }) => setStats(data)).catch(() => {});
  }, []);

  if (!stats) return <p className="text-neutral-400" data-testid="admin-loading">Loading…</p>;

  const cards = [
    { label: "Businesses", value: stats.businesses, icon: Building2, testid: "stat-businesses" },
    { label: "Active subscriptions", value: stats.active_subscriptions, icon: CreditCard, testid: "stat-subscriptions" },
    { label: "Forms built", value: stats.forms, icon: FileText, testid: "stat-forms" },
    { label: "Total submissions", value: stats.submissions, icon: Inbox, testid: "stat-submissions" },
  ];

  return (
    <div data-testid="admin-dashboard">
      <h1 className="text-3xl font-black">Platform overview</h1>
      <div className="mt-8 grid sm:grid-cols-2 lg:grid-cols-4 gap-4">
        {cards.map((c) => (
          <div key={c.label} className="bg-white border border-[#E5E5E5] rounded-2xl p-5" data-testid={c.testid}>
            <c.icon className="h-5 w-5 text-neutral-400" />
            <div className="mt-4 text-3xl font-black font-heading">{c.value}</div>
            <div className="text-xs text-neutral-500 mt-1">{c.label}</div>
          </div>
        ))}
      </div>
      <div className="mt-4 grid sm:grid-cols-2 gap-4">
        <div className="bg-neutral-900 text-white rounded-2xl p-6" data-testid="stat-mrr">
          <div className="text-xs uppercase tracking-widest text-neutral-400">Estimated MRR</div>
          <div className="mt-2 text-4xl font-black font-heading">£{stats.mrr.toLocaleString()}</div>
          <div className="text-xs text-neutral-400 mt-2">{stats.waived} business(es) have fees waived</div>
        </div>
        <Link to="/admin/businesses" data-testid="manage-businesses-link" className="bg-white border border-[#E5E5E5] rounded-2xl p-6 hover:shadow-sm transition-shadow duration-200 flex flex-col justify-between">
          <div className="text-xs uppercase tracking-widest text-neutral-400">Quick action</div>
          <div className="text-xl font-bold mt-2">Manage businesses →</div>
          <p className="text-sm text-neutral-500 mt-1">Change plans, waive fees, or log in as any business.</p>
        </Link>
      </div>
    </div>
  );
}
